export default {
    API: 'https://v1api.gi.connect.dp.gtfsr.swingbe.de/'
};
